import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const [tab, setTab] = useState('shop'); // 'admin' or 'shop'
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  const brand = host.startsWith('parlour') ? 'parlour' : host.startsWith('dentist') ? 'dentist' : 'barber';
  const brandName = brand === 'parlour' ? 'ParlourHub' : brand === 'dentist' ? 'DentistHub19' : 'BarberHub';
  const brandIcon = brand === 'parlour' ? '💄' : brand === 'dentist' ? '🦷' : '✂️';
  const shopLabel = brand === 'parlour' ? '💄 Parlour' : brand === 'dentist' ? '🦷 Dental Clinic' : '💈 Barber Shop';
  const bookingType = brand === 'parlour' ? 'Beauty Parlour' : brand === 'dentist' ? 'Dentist Appointment' : 'Barber';
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const url = tab === 'admin' ? '/api/auth/admin/login' : '/api/auth/shop/login';
      const res = await axios.post(url, form);
      login(res.data.token, res.data.user);
      toast.success(`Welcome, ${res.data.user.name}!`);
      navigate(tab === 'admin' ? '/admin' : '/dashboard');
    } catch (err) {
      const msg = err.response?.data?.message || 'Login fail ho gaya';
      if (err.response?.data?.code === 'ACCOUNT_SUSPENDED') {
        toast.error('Aapka account suspend hai. Admin se rabta karein.');
      } else if (err.response?.data?.code === 'SUBSCRIPTION_EXPIRED') {
        navigate('/subscription-expired');
      } else {
        toast.error(msg);
      }
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <div style={{ width: '100%', maxWidth: '420px' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <h1 style={{ fontFamily: 'Syne', fontSize: '36px', color: 'var(--accent)' }}>{brandIcon} {brandName}</h1>
          <p style={{ color: 'rgba(255,255,255,0.5)', marginTop: '8px' }}>Pakistan ka #1 {bookingType} Booking Platform</p>
        </div>

        <div className="card" style={{ borderRadius: '20px' }}>
          {/* Tabs */}
          <div style={{ display: 'flex', marginBottom: '28px', background: '#f5f5f5', borderRadius: '10px', padding: '4px' }}>
            {['shop', 'admin'].map(t => (
              <button key={t} onClick={() => setTab(t)} style={{
                flex: 1, padding: '10px', border: 'none', borderRadius: '8px', cursor: 'pointer',
                background: tab === t ? 'var(--primary)' : 'transparent',
                color: tab === t ? 'white' : 'var(--text-light)',
                fontFamily: 'Syne', fontWeight: 700, fontSize: '14px', transition: 'all 0.2s'
              }}>
                {t === 'shop' ? shopLabel : '👑 Master Admin'}
              </button>
            ))}
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Email Address</label>
              <input type="email" className="form-control" placeholder="email@example.com"
                value={form.email} onChange={e => setForm({...form, email: e.target.value})} required />
            </div>
            <div className="form-group">
              <label className="form-label">Password</label>
              <input type="password" className="form-control" placeholder="••••••••"
                value={form.password} onChange={e => setForm({...form, password: e.target.value})} required />
            </div>
            <button className="btn btn-primary btn-full btn-lg" type="submit" disabled={loading} style={{ marginTop: '8px' }}>
              {loading ? 'Logging in...' : `${tab === 'admin' ? '👑 Admin' : '💈 Shop'} Login`}
            </button>
          </form>

          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <a href="/" style={{ color: 'var(--accent)', fontSize: '13px', textDecoration: 'none' }}>
              ← Customer Booking page pe jayen
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
